import { FooterListItemProps } from './FooterListItem';

export type FooterSectionConfig = {
  title: string;
  items: FooterListItemProps[];
};

export const footerConfig: FooterSectionConfig[] = [
  // Products & Services
  {
    title: 'Products & Services',
    items: [
      {
        title: 'RMV Token',
        href: '#rmv',
      },
      {
        title: 'Reality Digital Assets',
        href: '#digital-assets',
      },
      {
        title: 'Map',
        href: 'https://realitymeta.io/home/portal/building/613',
      },
      {
        title: 'Digital Assets Store',
        route: 'STORE',
      },
      {
        title: 'Marketplace',
        href: 'https://realitymeta.io/home/market',
      },
      {
        title: '$RMV Staking',
        href: 'https://realitymeta.io/staking',
      },
      {
        title: 'Our Games (Play&Stake)',
        href: 'https://realitymeta.io/games',
      },
      {
        title: 'News',
        href: 'https://realitymeta.io/news',
      },
      {
        title: 'NFT Swap',
        route: 'NFT_SWAP',
      },
    ],
  },

  // Games
  {
    title: 'Games',
    items: [
      {
        title: 'Landlord GO',
        href: 'https://realitymeta.io/games/landlord-go',
      },
      // {
      //   title: 'AAA IP Game',
      //   href: 'https://reality.co/games/',
      // },
      {
        title: 'Weather Challenge',
        href: 'https://realitymeta.io/games/weather-challenge',
      },
      {
        title: 'Reality Rush',
        href: 'https://realitymeta.io/games/reality-rush',
      },
      {
        title: 'Donut Trumpet',
        href: 'https://realitymeta.io/games/donut-trumpet-tycoon',
      },
      {
        title: 'Streetvers',
        href: 'https://realitymeta.io/games/streetvers',
      },
      {
        title: 'Food Truck Tycoon',
        href: 'https://realitymeta.io/games/food-truck-tycoon',
      },
      {
        title: 'Speculate',
        href: 'https://realitymeta.io/games/speculate',
      },
    ],
  },

  // CEXs & DEXs
  {
    title: 'CEXs & DEXs',
    items: [
      {
        title: 'KuCoin',
        href: 'https://www.kucoin.com/trade/RMV-USDT',
      },
      {
        title: 'MEXC',
        href: 'https://www.mexc.com/pl-PL/price/RMV?calculatorTab=trade&utm_source=mexc&utm_medium=markets&utm_campaign=marketsdetails',
      },
      {
        title: 'LBank',
        href: 'https://www.lbank.com/pl/trade/rmv_usdt',
      },
      {
        title: 'Bitmart',
        href: 'https://www.bitmart.com/en-US/trade?symbol=RMV_USDT',
      },
      {
        title: 'Poloniex',
        href: 'https://www.poloniex.com/trade/RMV_USDT',
      },
      {
        title: 'Uniswap',
        href: 'https://app.uniswap.org/swap?chain=polygon&inputCurrency=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&outputCurrency=0xf0949dd87d2531d665010d6274f06a357669457a',
      },
      {
        title: 'Tonswap',
        href: 'https://tonswap.org/',
      },
    ],
  },

  // NFT Marketplaces
  {
    title: 'NFT Marketplaces',
    items: [
      {
        title: 'OpenSea',
        href: 'https://opensea.io/',
      },
      {
        title: 'Rarible',
        href: 'https://rarible.com/reality-nft/items',
      },
    ],
  },

  // About us
  {
    title: 'About us',
    items: [
      {
        title: 'Our Projects',
        href: 'https://youtu.be/GUtYBvKPzYg',
      },
      {
        title: 'Our Company',
        href: 'https://youtu.be/lQQUKr8e7T8',
      },
      {
        title: 'Our Games',
        href: 'https://youtu.be/R7MoIQeH7Gc',
      },
      {
        title: 'Marketing Launch',
        href: 'https://youtu.be/22WfGaErE1M',
      },
    ],
  },

  // Events (placeholder for future implementation)
  {
    title: 'Events',
    items: [
      // Will be added when events are implemented
      // {
      //   title: 'Last event 1',
      //   href: '#', // placeholder
      // },
      // {
      //   title: 'Last event 2',
      //   href: '#', // placeholder
      // },
      // {
      //   title: 'Last event 3',
      //   href: '#', // placeholder
      // },
    ],
  },

  // Organization
  {
    title: 'Organization',
    items: [
      {
        title: 'Railway 3.0',
        href: 'https://railway3.com/',
      },
      {
        title: 'Contact',
        href: 'https://realitymeta.io/contact',
      },
      {
        title: 'Media',
        href: 'https://realitymeta.io/media',
      },
      {
        title: 'Referrals',
        route: 'REFERRALS',
      },
      {
        title: 'Whitepaper',
        href: '#whitepaper', // anchor from current menu
      },
      {
        title: 'Reality Games',
        href: 'https://reality.co/',
      },
    ],
  },

  // Medium Articles
  {
    title: 'Medium Articles',
    items: [
      {
        title: 'August Q&A — Communi...',
        href: 'https://medium.com/@Realitymeta/reality-metaverse-august-q-a-community-answers-before-the-ama-5a54915bb82f',
      },
      {
        title: 'World NFT: The Ultimate...',
        href: 'https://medium.com/@Realitymeta/introducing-world-nft-the-ultimate-asset-of-reality-ecosystem-42f443d1b089',
      },
      {
        title: 'Big Changes, Big Vision:...',
        href: 'https://medium.com/@Realitymeta/big-changes-big-vision-reshaping-side-assets-and-the-future-of-reality-digital-assets-09cf94240c21',
      },
      {
        title: 'Reality Metaverse × Re...',
        href: 'https://medium.com/@Realitymeta/reality-metaverse-reality-games-community-event-conference-2025-4be13cb35487',
      },
      {
        title: '$RMV Token Royalties U...',
        href: 'https://medium.com/@Realitymeta/rmv-token-royalties-update-ffef29cd95bf',
      },
    ],
  },
];
